module.exports = __webpack_public_path__ + "static/demo-5ef777e36141547b9d638d2f0d927e8d.mp4";